module.exports = "<svg class=\"AddressControl-geoIcon\" viewBox=\"0 0 28 28\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#7290CB\" fill-rule=\"evenodd\"><path d=\"M14 5a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm0 1.97a7.03 7.03 0 1 1 0 14.06 7.03 7.03 0 0 1 0-14.06z\"></path><path d=\"M19 13h8v2h-8v-2zM1 13h8v2H1v-2zm12 6h2v8h-2v-8zm0-18h2v8h-2V1zm1 10.82z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/AddressControl/goal.svg
// module id = 1988
// module chunks = 0